// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__38VT1","arrowIcon":"DateRangeController_arrowIcon__dHWxi"};